import { BREAD_SLICE_RATIO, CREDIT_USD_RATIO } from '../../constants/general';
import { PartialRecordEnumValue } from '../Utils';

export enum BalanceType {
  Exp = 'exp',
  Coin = 'coin',
  Diamond = 'diamond',
  Token = 'token',
  JoyPoint = 'joyPoint',
  CreationToken = 'creationToken',
  // TokenAllowance = 'tokenAllowance',
  // Ticket = 'ticket',
  BreadSlice = 'breadSlice',
  // Bread = 'bread',
  Credit = 'credit',
  ServiceToken = 'serviceToken',
}

export type BalanceJson = PartialRecordEnumValue<typeof BalanceType, number>;

export class Balance implements Required<BalanceJson> {
  exp: number;
  coin: number;
  diamond: number;
  token: number;
  joyPoint: number;
  creationToken: number;
  credit: number;
  breadSlice: number;
  serviceToken: number;

  // tokenAllowance: number;
  // ticket: number;

  constructor(json: BalanceJson) {
    this.exp = json.exp ?? 0;
    this.coin = json.coin ?? 0;
    this.diamond = json.diamond ?? 0;
    this.token = json.token ?? 0;
    this.joyPoint = json.joyPoint ?? 0;
    this.creationToken = json.creationToken ?? 0;
    this.credit = json.credit ?? 0;
    // this.tokenAllowance = json.tokenAllowance ?? 0;
    // this.ticket = json.ticket ?? 0;
    this.breadSlice = json.breadSlice ?? 0;
    this.serviceToken = json.serviceToken ?? 0;
  }

  get bread(): number {
    return Math.trunc(this.breadSlice / BREAD_SLICE_RATIO);
  }

  get usDollar(): number {
    return this.credit / CREDIT_USD_RATIO;
  }

  get isEmpty(): boolean {
    return (
      this.exp === 0 &&
      this.coin === 0 &&
      this.diamond === 0 &&
      this.token === 0 &&
      this.joyPoint === 0 &&
      this.creationToken === 0 &&
      this.credit === 0 &&
      // this.tokenAllowance === 0 &&
      // this.ticket === 0 &&
      this.breadSlice === 0 &&
      this.serviceToken === 0
    );
  }

  toJSON(): BalanceJson {
    return Object.values(BalanceType).reduce<BalanceJson>((acc, k) => {
      const v = this[k];
      if (v > 0) {
        acc[k] = v;
      }
      return acc;
    }, {});
  }
}

export enum RewardType {
  PuzzlePiece = 'puzzlePiece',
  ClassroomCredit = 'classroomCredit',
}
export interface Reward extends BalanceJson {
  puzzlePiece?: number;
  classroomCredit?: number;
}
